import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';

import DialogTitle from '../DialogTitle';

/**
 * プロパティ
 */
export type Props = {
  /** 閉じる */
  close: (isYes: boolean) => void,
  /** タイトル */
  title: string,
  /** コンテント */
  content: string,
}

const MessageBox: React.FC<Props> = ({
  close,
  title,
  content,
}) => (
  <Dialog
    open
    onClose={() => close(false)}
  >
    <DialogTitle title={title} />
    <DialogContent>
      <p>{content}</p>
    </DialogContent>
    <DialogActions>
      <Button variant="contained" onClick={() => close(true)} color="primary">
        はい
      </Button>
      <Button variant="contained" onClick={() => close(false)} color="primary">
        いいえ
      </Button>
    </DialogActions>
  </Dialog>
);

export default MessageBox;
